import { Action } from '@ngrx/store';
import { UnitV2 } from '@cemex-core/cmx-api';

export enum AdtUnitsActionTypes {
    FETCH_UNITS_BY_PRODUCT = '[ADT Unit] Fetch Unit By Product',
    LOAD_UNITS = '[ADT Unit] Load Unit Of Contracts',
    LOAD_UNITS_BY_PRODUCT = '[ADT Unit] Load Units Of Products',
    RESET = '[ADT Unit] Reset',
}

/**
 * Fetch units of products with API V4
 */
export class FetchAdtUnitsProductAction implements Action {
    readonly type = AdtUnitsActionTypes.FETCH_UNITS_BY_PRODUCT;

    constructor(public payload: string) { }
}

/**
 * Loads Units of Contracts
 */
export class LoadAdtUnitsAction implements Action {
    readonly type = AdtUnitsActionTypes.LOAD_UNITS;

    constructor(public payload: UnitV2[]) { }
}

/**
 * Loads Units of Produc selected
 */
export class LoadAdtUnitsOfProductAction implements Action {
    readonly type = AdtUnitsActionTypes.LOAD_UNITS_BY_PRODUCT;

    constructor(public payload: {units: UnitV2[], productCode: string}) { }
}

/**
 * Reset admixture unit store
 */
export class AdtResetUnitsAction implements Action {
    readonly type = AdtUnitsActionTypes.RESET;

    constructor() { }
}

export type AdtUnitsActions =
    | LoadAdtUnitsAction
    | FetchAdtUnitsProductAction
    | LoadAdtUnitsOfProductAction
    | AdtResetUnitsAction;
